import script from "./join.vue?vue&type=script&setup=true&lang=js"
export * from "./join.vue?vue&type=script&setup=true&lang=js"

import "./join.vue?vue&type=style&index=0&id=37381a78&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37381a78"]])

export default __exports__